var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.995,
    height: 17.003,
    viewBox: "0 0 31.995 17.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line_Expand",
    transform: "translate(0.003 -7.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M16,24.5a1.024,1.024,0,0,1-.71-.29l-15-15A1,1,0,0,1,1.7,7.8L16,22.09,30.29,7.79A1,1,0,0,1,31.7,9.2l-15,15A.954.954,0,0,1,16,24.5Z",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomArrowDark);
export default __webpack_public_path__ + "static/media/bottom_arrow_dark.fb8c1e8415ccc10f36a519ba354c48aa.svg";
export { ForwardRef as ReactComponent };